import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import { RegimeAllocation } from '../constants/regimes';

interface RegimeAllocationPieProps {
  allocation: RegimeAllocation;
  language?: string;
}

export function RegimeAllocationPie({ allocation, language = 'ko' }: RegimeAllocationPieProps) {
  const isKo = language === 'ko';

  const normalize = (val: number | undefined | null) => {
    if (!val || isNaN(val)) return 0;
    return val > 1.0 ? val / 100.0 : val;
  };

  const data = [
    { name: isKo ? '주식' : 'Equities', value: normalize(allocation.equities), color: '#60a5fa' },
    { name: isKo ? '채권' : 'Bonds', value: normalize(allocation.bonds), color: '#34d399' },
    { name: isKo ? '원자재' : 'Commodities', value: normalize(allocation.commodities), color: '#fb923c' },
    { name: isKo ? '현금' : 'Cash', value: normalize(allocation.cash), color: '#94a3b8' },
  ].filter(item => item.value > 0);

  return (
    <div className="flex-1 w-full min-h-[200px] relative min-w-0">
      <ResponsiveContainer width="100%" height={200} minWidth={0} minHeight={0}>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={60}
            outerRadius={80}
            paddingAngle={5}
            dataKey="value"
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} stroke="none" />
            ))}
          </Pie>
          <Tooltip
            contentStyle={{
              backgroundColor: 'rgba(0, 0, 0, 0.85)',
              border: '1px solid rgba(255, 255, 255, 0.15)',
              borderRadius: '12px',
              color: '#fff',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
              backdropFilter: 'blur(8px)',
              padding: '8px 12px',
            }}
            formatter={(value: any, name: any) => {
              const num = typeof value === 'number' ? value : parseFloat(value) || 0;
              const pct = num > 1.0 ? num : num * 100;
              return [`${pct.toFixed(1)}%`, name];
            }}
          />
          <Legend 
            verticalAlign="bottom" 
            height={36}
            formatter={(value) => <span className="text-[10px] text-white/60 uppercase font-bold tracking-wider">{value}</span>}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
